import axios from '../helpers/axios-auth';

class ProductGroupService {
  getProductGroupByStatus(status,size=11) {
    let params = { status,size };
    return axios.get('/product-groups', { params });
  }
  getProductGroupDetailById(id, page, size) {
    if (!page) page = 0;
    else page -= 1;

    if (!size) size = 2;

    let params = { page, size };
    return axios.get(`/product-group/${id}`, { params });
  }
  getProductGroupDetailItem(id, filterParams, page, size) {
    if (!page) page = 0;
    else page -= 1;

    if (!size) size = 2;
    let params = { productGroupId: id, page, size };
    if (filterParams.name) params['name'] = filterParams.name;

    if (filterParams.brandId) params['brandId'] = filterParams.brandId;

    if (filterParams.categoryId) params['categoryId'] = filterParams.categoryId;

    if (filterParams.registerId) params['registerId'] = filterParams.registerId;
    
    return axios.get('/product-group-details', { params });
  }
  getCategoryList() {
    return axios.get('/all-pg-category');
  }
}

export default new ProductGroupService();
